import type { IdentityFormData } from './identityHelpers'

export type BillingDetails = {
  name: string | null
  email: string | null
  phone: string | null
  address: {
    country: string | null
    postal_code: string | null
    state: string | null
    city: string | null
    line1: string | null
    line2: string | null
  }
}

export type BillingDetailsResult = { status: 'success'; data: BillingDetails } | { status: 'error'; error: string }

export function billingDetails(identity: IdentityFormData): BillingDetails {
  function getValue(key: string): string | null {
    const value = identity[key]
    if (value && typeof value === 'string' && value.length > 0) {
      return value
    }
    return null
  }

  return {
    name: getValue('name'),
    email: getValue('email'),
    phone: getValue('phone'),
    address: {
      country: getValue('country'),
      postal_code: getValue('zip_code'),
      state: getValue('state'),
      city: getValue('city'),
      line1: getValue('address'),
      line2: getValue('address_more'),
    },
  }
}
